import { Popover, backdropClasses, popoverClasses, styled } from '@mui/material';

const TabFilterPopover = styled(Popover)({
  [`& .${popoverClasses.paper}`]: {
    width: 600,
    maxWidth: 600,
    borderRadius: '8px',
    backgroundColor: 'white',
    border: 'none',
    boxShadow: '0 10px 10px 0 rgb(16 10 85 / .1)',
    display: 'flex',
    flexGrow: 1,
  },
  [`& .${backdropClasses.root}`]: {
    backgroundColor: 'rgb(0 0 0 / .4)',
  },
});

export default TabFilterPopover;
